import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveDeviceWorkStation } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import { selectDeviceWorkStationModel } from 'selectors/entitySelector';
import { initializeDeviceWorkStationForm } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';

class DeviceWorkStationSave extends Component {

    componentWillMount = () => {
        this.props.init();
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != null && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != null && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess){
                this.saveSuccess();
            }
            else if(newProps.workStationName == ""){
                this.saveEmpty();
            }    
            else{
                this.saveFailure();
            }
        }
    }

    saveRole = () => {
        this.props.save(this.props.workstationModel);
    }

    saveSuccess = () => {
        this.props.showSnackbar(LOOKUP.deviceWorkStations.saveMessage);

        if (this.props.onSave) {
            this.props.onSave();
        }
    }

    saveFailure = () => {
        this.props.showError(LOOKUP.deviceWorkStations.saveErrorMessage);
    }

    saveEmpty = () => {
        this.props.showError(LOOKUP.deviceWorkStations.saveEmptyMessage);
    }

    render() {
        const p = this.props;
        return (
            <div style={{overflowY:"unset"}}>
                <div className="row">
                    <div className="col-lg-12">
                        <TextInput
                            name={`${p.name}Name`}
                            fullWidth={true}
                            label={LOOKUP.deviceWorkStations.name.label}
                            floatingLabelText={LOOKUP.deviceWorkStations.name.label}
                            hintText={LOOKUP.deviceWorkStations.name.hintText}
                            maxLength={20} />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-12">
                        <Button
                            name="saveButton"
                            className="pull-right btnNewBrandPOS site_1-1rem"
                            label={LOOKUP.deviceWorkStations.controls.saveButton}
                            primary={true}
                            onTouchTap={() => this.saveRole()} />
                        <Button
                            type="cancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation site_1-1rem"
                            label={LOOKUP.deviceWorkStations.controls.cancelButton}
                            onTouchTap={() => p.onCancel()} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        workstationModel: selectDeviceWorkStationModel(state, props.name),
        saveSuccess: state.form[props.name + "SaveSuccess"],
        saveError: state.form[props.name + "SaveError"],
        workStationName: state.form.deviceSaveWorkStationName
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        save: (model) => dispatch(saveDeviceWorkStation(model, props.name)),
        init: () => dispatch(initializeDeviceWorkStationForm(props.name)),
        showError: (message) => dispatch(showError(message)),
        showSnackbar: (message) => dispatch(showSnackbar(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(DeviceWorkStationSave);